import React from "react";
import { Link } from "react-router-dom";
import styles from "./PortfolioSection.module.css";

const categories = [
  {
    title: "Residential",
    image: "/media/r1 copy.jpg",
    link: "/projects?category=Residential",
  },
  {
    title: "Commercial",
    image: "/commercial/PHOTO-2026-07-08-13-58-29.jpg",
    link: "/projects?category=Commercial",
  },
  {
    title: "Renovations",
    image: "/media/l1 copy.jpg",
    link: "/projects?category=Renovations",
  },
];

const PortfolioSection = () => {
  return (
    <section id="portfoliosection" className={styles.blog}>
      <div className={styles.header}>
        <div className={styles.tag}>PORTFOLIO</div>
        <h2 className={styles.title}>TRUST THE PROCESS</h2>
        <p className={styles.subtitle} style={{ maxWidth: "800px", margin: "0 auto", paddingBottom: "20px" }}>
          At ShaKa Design Lab, we believe that successful interior design is a collaborative and structured journey. Our comprehensive design process ensures that every project is thoughtfully planned and beautifully executed. Explore our range of beautifully executed projects across different domains.
        </p>
        <Link to="/process" style={{ fontWeight: "500", color: "#181818", textDecoration: "none", borderBottom: "2px solid #181818", paddingBottom: "4px", fontSize: "1rem", textTransform: "uppercase", letterSpacing: "1px", transition: "all 0.3s ease" }}>
          SEE OUR FULL PROCESS
        </Link>
      </div>

      <div className={styles.cardsGrid}>
        {categories.map((cat, idx) => (
          <Link to={cat.link} key={idx} className={styles.card}>
            <div className={styles.imageContainer}>
              <img src={cat.image} alt={cat.title} className={styles.image} />
              <div className={styles.overlay}>
                <span className={styles.viewProjectText}>View Projects</span>
              </div>
            </div>
            <h3 className={styles.cardTitle}>{cat.title}</h3>
          </Link>
        ))}
      </div>
    </section>
  );
};
export default PortfolioSection;
